import { ShareModal as GenericShareModal } from '@eventbrite/consumer-search.share-modal';
import type { Collection } from '@/types/collection';
import { EVENTBRITE_FACEBOOK_APP_ID } from '@/constants/share';

interface Props {
  isShown: boolean;
  onClose: () => void;
  collection: Collection;
}

export function CollectionShareModal({ isShown, onClose, collection }: Props) {
  return (
    <GenericShareModal
      isShown={isShown}
      onClose={onClose}
      resourceName={collection.title}
      resourceUrl={collection.url}
      resourceType="collection"
      resourceId={collection.id}
      facebookAppId={EVENTBRITE_FACEBOOK_APP_ID}
      messageTemplate={{
        id: 'Check out this collection: {collectionTitle} {collectionUrl}',
        defaultMessage: 'Check out this collection: {collectionTitle} {collectionUrl}',
      }}
      messageValues={{
        collectionTitle: collection.title,
        collectionUrl: collection.url,
      }}
    />
  );
}
